// extracted by mini-css-extract-plugin
export default {"tooltip":"Fo-z","sharingV2":"Go-z","sharingIconsV2":"Ho-z","links":"Io-z","link":"Jo-z","facebookV2":"Ko-z","twitterV2":"Lo-z","pinterestV2":"Mo-z"};